module.exports = __webpack_public_path__ + "static/img/apk_code.ea95e13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apk_code.png
// module id = BuJF
// module chunks = 1